module.exports = __webpack_public_path__ + "static/top-image-a15c88df63893b9eb7a32c5c093a5876.svg";